import React from "react";

type DangerAlertProps = {
    children: React.ReactNode;
};

function DangerAlert({ children }: DangerAlertProps) {
    return <div className="alert alert-danger">{children}</div>;
}

export default DangerAlert;
